import React, { useState } from 'react';
import { FAQS } from '../utils/config';
export default function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <section id="faq" style={{background:'var(--mint-p)',padding:'96px 36px'}}>
      <div style={{maxWidth:'680px',margin:'0 auto'}} className="reveal">
        <div className="section-tag">Questions</div>
        <h2 className="section-title">Frequently <em>Asked</em></h2>
        <div style={{marginTop:'44px'}}>
          {FAQS.map(([q,a],i)=>(
            <div key={i} style={{borderBottom:'.5px solid var(--sage-p)'}}>
              <div onClick={()=>setOpen(open===i?null:i)} style={{padding:'20px 0',fontFamily:'var(--font-serif)',fontSize:'19px',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',color:open===i?'var(--sage)':'var(--deep)',transition:'color .2s',userSelect:'none'}}>
                {q}
                <span className={`faq-toggle${open===i?' open':''}`} style={{width:'21px',height:'21px',borderRadius:'50%',border:'.5px solid var(--sage-p)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',color:'var(--sage)',flexShrink:0}}>+</span>
              </div>
              <div className={`faq-answer${open===i?' open':''}`} style={{fontSize:'13px',color:'var(--muted)',lineHeight:1.9}}>{a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
